<template>

    <svg xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        viewBox="0 0 74 70"
        role="presentation"
    >
        <g 
            style="fill:#4d4d4d" 
            id="fermeBio" 
            transform="translate(14, 0)">
            <path
                d="m 23.834375,27.100204 c -0.135,0.135 -0.213,0.322 -0.213,0.513 0,0.192 0.078,0.378 0.213,0.514 0.135,0.134 0.323,0.212 0.513,0.212 0.192,0 0.379,-0.078 0.514,-0.212 0.134,-0.136 0.212,-0.322 0.212,-0.514 0,-0.191 -0.078,-0.378 -0.212,-0.513 -0.135,-0.136 -0.322,-0.213 -0.514,-0.213 -0.19,0 -0.378,0.077 -0.513,0.213" />
            <path
                d="m 17.335451,22.347025 v -5.328 h 6.849 v 4.089 c -1.244,0.514 -2.459,1.102 -3.637,1.764 -0.376,0.211 -0.748,0.431 -1.116,0.656 -0.687,-0.419 -1.385,-0.814 -2.096,-1.181 m -3.92,-1.732 c -0.576,-0.212 -1.157,-0.41 -1.742,-0.589 v -0.55 h 1.742 z m -4.211,-3.596 h 6.679 v 4.616 c -0.336,-0.154 -0.675,-0.304 -1.016,-0.447 v -2.439 c 0,-0.4 -0.325,-0.725 -0.726,-0.725 h -3.195 c -0.4,0 -0.725,0.325 -0.725,0.725 v 0.864 c -0.338,-0.088 -0.676,-0.171 -1.017,-0.249 z m 3.339,-3.786 2.321,2.334 h -4.64 z m 10.621,2.334 h -6.253 l -2.622,-2.637 h 6.253 z M 3.1544513,9.9290254 c 0,-1.853 0.829,-3.611 2.348,-5.0090001 1.5179997,1.3980001 2.3459997,3.1560001 2.3459997,5.0090001 0,1.5289996 -0.566,2.9969996 -1.6209997,4.2499996 V 9.3490254 c 0,-0.402 -0.325,-0.728 -0.725,-0.728 -0.401,0 -0.727,0.326 -0.727,0.728 v 4.8299996 c -1.054,-1.253 -1.621,-2.721 -1.621,-4.2499996 m 23.9389997,-0.677 c 0,-2.581 1.181,-5.0240001 3.339,-6.9390001 2.158,1.915 3.338,4.3580001 3.338,6.9390001 0,2.2739996 -0.917,4.4429996 -2.612,6.2369996 V 9.9290254 c 0,-0.401 -0.325,-0.727 -0.726,-0.727 -0.401,0 -0.726,0.326 -0.726,0.727 v 5.5599996 c -1.695,-1.794 -2.613,-3.963 -2.613,-6.2369996 m -15.836,23.5739996 c 4.777,-6.227 11.69,-10.552 19.32,-12.172 0,0 0.002,-0.001 0.003,-0.001 2.193,-0.466 4.444,-0.708 6.72,-0.708 0.401,0 0.726,-0.326 0.726,-0.727 0,-0.4 -0.325,-0.725 -0.726,-0.725 -2.064,0 -4.121,0.189 -6.142,0.557 v -1.566 c 2.624,-2.221 4.064,-5.132 4.064,-8.2319996 0,-3.2050001 -1.539,-6.2090001 -4.335,-8.45600015 -0.266,-0.214 -0.644,-0.214 -0.91,0 -2.796,2.24700005 -4.336,5.25100005 -4.336,8.45600015 0,3.0999996 1.441,6.0109996 4.065,8.2319996 v 1.865 c -1.38,0.312 -2.739,0.713 -4.071,1.195 v -4.251 c 0,-0.2 -0.08,-0.381 -0.21,-0.511 v -0.001 l -4.066,-4.089 c -0.136,-0.137 -0.321,-0.214 -0.515,-0.214 h -8.301 c -0.193,0 -0.378,0.077 -0.514,0.214 l -4.065,4.089 v 0.001 c -0.131,0.13 -0.212,0.311 -0.212,0.511 v 2.773 c -0.506,-0.092 -1.014,-0.174 -1.5249997,-0.244 v -2.588 c 1.9849997,-1.707 3.0729997,-3.934 3.0729997,-6.3049996 0,-2.478 -1.187,-4.7980001 -3.3439997,-6.5310001 -0.266,-0.213 -0.644,-0.213 -0.91,0 -2.156,1.733 -3.344,4.0530001 -3.344,6.5310001 0,2.3699996 1.089,4.5979996 3.073,6.3049996 v 2.421 c -1.058,-0.099 -2.124,-0.151 -3.194,-0.151 -0.401,0 -0.72500005,0.325 -0.72500005,0.727 0,0.4 0.32400005,0.725 0.72500005,0.725 5.8049997,0 11.4839997,1.537 16.4889997,4.451 -1.199,0.815 -2.345,1.705 -3.429,2.663 -4.056,-2.067 -8.5619997,-3.158 -13.0599997,-3.158 -0.401,0 -0.72500005,0.327 -0.72500005,0.728 0,0.399 0.32400005,0.725 0.72500005,0.725 4.093,0 8.1929997,0.953 11.9189997,2.759 -1.104,1.068 -2.135,2.21 -3.088,3.417 -2.823,-1.183 -5.7919997,-1.784 -8.8309997,-1.784 -0.401,0 -0.72500005,0.325 -0.72500005,0.727 0,0.4 0.32400005,0.725 0.72500005,0.725 2.723,0 5.3849997,0.517 7.9269997,1.534 -0.502,0.697 -0.978,1.412 -1.427,2.148 l -1.106,1.811 c -0.209,0.342 -0.101,0.79 0.242,0.999 0.118,0.072 0.248,0.106 0.377,0.106 0.245,0 0.484,-0.123 0.621,-0.349 l 1.106,-1.811 c 0.576,-0.946 1.2,-1.856 1.864,-2.729 0.026,-0.028 0.051,-0.059 0.072,-0.092" />
            <path
                d="m 37.300451,24.017392 c -3.246,0 -6.458,0.556 -9.548,1.648 -0.378,0.133 -0.576,0.548 -0.442,0.926 0.105,0.298 0.385,0.486 0.684,0.486 0.08,0 0.162,-0.015 0.242,-0.042 2.934,-1.039 5.983,-1.566 9.064,-1.566 0.401,0 0.726,-0.325 0.726,-0.725 0,-0.402 -0.325,-0.727 -0.726,-0.727" />
            <path
                d="m 21.665184,29.073025 c -0.225,-0.332 -0.675,-0.419 -1.008,-0.194 -3.104,2.096 -5.726,4.72 -7.793,7.798 -0.223,0.333 -0.135,0.784 0.198,1.006 0.124,0.084 0.265,0.124 0.405,0.124 0.233,0 0.462,-0.113 0.603,-0.321 1.962,-2.922 4.451,-5.413 7.4,-7.404 0.332,-0.225 0.42,-0.677 0.195,-1.009" />
            <path
                d="m 37.300451,29.746025 c -6.063,0 -12.013999,2.487 -16.326999,6.824 -0.283,0.283 -0.281,0.743 0.002,1.026 0.143,0.141 0.327,0.211 0.513,0.211 0.186,0 0.373,-0.071 0.515,-0.214 4.042,-4.064 9.616999,-6.395 15.296999,-6.395 0.401,0 0.726,-0.325 0.726,-0.726 0,-0.401 -0.325,-0.726 -0.726,-0.726" />
        </g>
        <text
            class="textBig"
            id="nbFerme"
            x="34"
            y="52"
        >
            {{nbFerme}}
        </text>
        <text>
            <tspan class="textComments" x="35" y="61">FERMES</tspan>
            <tspan class="textComments" x="35" y="70">ENGAGÉES EN BIO</tspan>
        </text>

    </svg>
</template>

<script>
    export default {
        props: {
            nbFerme: {
                type: Number,
                default: null
            },
            width: {
                type: [Number, String],
                default: 70
            },
            height: {
                type: [Number, String],
                default: 74
            },
        }     
    }
</script>

<style scoped>
    .textBig {
        font-size: 14px;
        font-weight: 900;
        text-align: center;
        text-anchor: middle;
        fill:#F7CF0F
    }
    .textComments {
        font-size: 8px;
        font-weight: 700;
        font-style: italic;
        text-align: center;
        text-anchor: middle;
        fill:#313131
    }
</style>